export const GetPromotionContents = `
  query promotionContents($partner: PromotionPartner, $promotionCodes: [String!]) {
    promotions(where: {
      partnership: $partner,
      codes_contains_all: $promotionCodes
    }) {
      title
      codes
      imageBanner {
        url
        width
        height
      }
      imageSquare {
        url
        width
        height
      }
      heading
      summary
      details {
        html
      }
      disclaimer {
        html
      }
    }
  }
`;
